import React, { FC } from 'react';
import MuiStepContent, { StepContentProps as MuiStepContentProps } from '@mui/material/StepContent';
import { BpDesignSystem } from '../../types';

export type StepContentProps = BpDesignSystem.PropsWithChildren<MuiStepContentProps>;

export const StepContent: FC<StepContentProps> = ({ dataTest, ...rest }) => (
  <MuiStepContent data-test={dataTest} {...rest} />
);
